import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import SydModal from '../../../../../commonDesign/SydModal'
import ModifyDatasourceAlwaysAvailableForm from './form'

const ModifyDatasourceAlwaysAvailableDialog = React.forwardRef(function ModifyDatasourceAlwaysAvailableDialog ({ onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false })

  const close = useCallback(() => {
    setDialogState({ open: false, processing: false })
  }, [setDialogState])

  const handleComplete = useCallback((e) => {
    close()
    onComplete(e)
  }, [close, onComplete])

  useImperativeHandle(ref, () => ({
    open: (dataSource) => setDialogState({
      open: true,
      processing: false,
      dataSource
    })
  }), [setDialogState])

  return (
    <SydModal
      title='Always Available Settings'
      open={dialogState.open}
      onClose={close}
      size='md'
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (
          <ModifyDatasourceAlwaysAvailableForm
            dataSource={dialogState.dataSource}
            onComplete={handleComplete}
            onCancel={close}
          />
        ) : null}
      </div>
    </SydModal>
  )
})

ModifyDatasourceAlwaysAvailableDialog.propTypes = {
  onComplete: PropTypes.func
}

ModifyDatasourceAlwaysAvailableDialog.defaultProps = {
  onComplete: () => {}
}

export default ModifyDatasourceAlwaysAvailableDialog
